import React, { Component } from "react";
import { connect } from "react-redux";
import Grid from "../../../../../../components/grid";
import RadiosRenderer from "../../../../../../components/grid/RadiosRenderer";
import filter from "lodash/filter";
//import scss
import "./earningCode.scss";
import { saveSOHSettings } from "../../../../../../store/actions";
class EarningCode extends Component {
  constructor(props) {
    super(props)
  }
  state = {
    columnDefs: [

      {
        headerName: "Earning Code",
        field: "earningCode",
        width: 115,

      },
      {
        headerName: "Abbreviation",
        field: "abbreviation",
        resizable: true,
        width: 100,

      },
      {
        headerName: "External Id",
        field: "externalId",
        resizable: true,
        width: 100,
      },
      {
        headerName: "Earning Type",
        field: "earningType",
        resizable: true,
        width: 235,
        cellRenderer: RadiosRenderer,
        cellRendererParams: {
          //onChanged: (params) => this.onClickEarningType(params),
          radioValues: [{ val: "regular", label: "Regular" }, { val: "overtime", label: "Overtime" }, { val: "excluded", label: "Excluded" }],
          nameProp: "systemId"
        },
      }

    ],
    rowData: [],
    earningCodes: []
  };

  async componentDidMount() {
    this.setState({ earningCodes: this.props.earningCodes })
  };

  async componentDidUpdate(prevProps, prevState) {
    if (!prevProps.SOH_SETTINGS.earningCodes && this.props.SOH_SETTINGS.earningCodes) {
      this.setState({ earningCodes: this.props.SOH_SETTINGS.earningCodes });
    };
  };


  onClickEarningType = (data) => {
    /* 
        let found = this.state.earningCodes.find(res => res.systemId === data.systemId);
        //this.earningCodes[findIndex] = data;
        this.setState({ earningCodes: this.earningCodes }); */
  };

  setCounters = () => {
    this.setState({
      counts: {
        regular: (filter(this.state.earningCodes, { earningType: "regular" })).length,
        overtime: (filter(this.state.earningCodes, { earningType: "overtime" })).length,
        exclude: (filter(this.state.earningCodes, { earningType: "exclude" })).length,
      }
    });
  };


  saveChanges = async () => {
    let earningCodes = this.state.earningCodes.map(el => ({ earningType: el.earningType, code: el.code?._id || el._id }))
    await this.props.saveSOHSettings(this.props.ClientDataReducer._id,
      {
        earningCodes,
        companyShortName: this.props.ClientDataReducer.companyShortName
      });
  };

  render() {
    return (
      <>
        <div className="full-box mt-0">
          <div className="filter-list d-flex align-items-center justify-content-between">

            <div className="filter-field d-flex">
              <button className="mla fs12 primary mini" onClick={this.saveChanges} disabled={""}>Save</button>
            </div>
          </div>
          <div className="clients_grid">
            <Grid
              columnDefs={this.state.columnDefs}
              rowData={this.state.earningCodes}
              height='600px'
            >
            </Grid>
          </div>
        </div>
      </>
    );
  };
};

const mapStateToProps = ({ ClientDataReducer, SOHSettingsReducer }) => {
  let { SOH_SETTINGS } = SOHSettingsReducer;
  SOH_SETTINGS = SOH_SETTINGS || {};
  let { earningCodes } = SOH_SETTINGS;
  return { ClientDataReducer, SOH_SETTINGS, earningCodes };
};
export default connect(mapStateToProps, {
  saveSOHSettings
})(EarningCode);